import { Basket, BasketItem } from 'src/types/basket';

const defaults: Readonly<Basket> = {
  itemsCount: 0,
  items: [],
};

export const basketItemOptionsBuilder = (itemOptions?: Partial<BasketItem>) => ({
  id: '1',
  options: [],
  quantity: 1,
  ...itemOptions,
});

export const basketBuilder = (product?: Partial<Basket>): Readonly<Basket> => ({
  ...defaults,
  ...product,
});
